// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_zXB","cls2":"CollapsedActivityPreview-cls2_mo4 CollapsedActivityPreview-cls1_zXB"};